import { H1 } from 'baseui/typography';
import React from 'react';
import AuthFlow from '../components/login/AuthFlow';
import { withAuthentication } from '../firebase/session';

const AuthView = ({ firebase }) => {
  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <H1>Login to Living Ledger</H1>
      <AuthFlow firebase={firebase} />
    </div>
  );
}

export default withAuthentication(AuthView);
